<template>
  <md-autocomplete
    v-model="selectedLanguage"
    :md-options="languageOptions"
    :md-fuzzy-search="false"
    @md-changed="emitUpdate"
    @md-selected="emitUpdate"
  >
    <label>{{ label }}</label>

    <template
      slot="md-autocomplete-item"
      slot-scope="{ item, term }"
    >
      <md-highlight-text :md-term="term">
        {{ item }}
      </md-highlight-text>
    </template>
  </md-autocomplete>
</template>
<script>
    import {languageOptions, languageNameToCode, languageCodeToName} from "@/assets/countries_iso/language-codes";

    export default {
        props: {
            label: {
                type: String,
                default: "Language"
            },
            language: {
                type: String,
                default: ""
            },
        },
        data() {
            return {
                languageOptions,
                selectedLanguage: languageCodeToName[this.$props.language],
            };
        },
        watch: {
            country() {
                if (this.selectedLanguage !== languageCodeToName[this.$props.language]) {
                    this.selectedLanguage = languageCodeToName[this.$props.language];
                }
            },
        },
        methods: {
            emitUpdate() {
                this.$emit("languageSelected", languageNameToCode[this.selectedLanguage] || "invalid");
            },
        },
    };
</script>
<style>
    .md-menu-content-bottom-start {
        width: 350px !important;
        max-width: 350px !important;
    }
</style>